var $9d6e6789429d726c$exports = {};
$9d6e6789429d726c$exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Fargevelger`,
    "colorSwatch": `fargekart`,
    "transparent": `gjennomsiktig`,
    "twoDimensionalSlider": `2D-glidebryter`
};


export {$9d6e6789429d726c$exports as default};
//# sourceMappingURL=nb-NO.mjs.map
